import { Routes, Route } from "react-router-dom";
import { useAdmin } from "../context/AdminAuth";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import Overview from "./pages/Overview";
import Products from "./pages/Products";
import ProductEdit from "./pages/ProductEdit";
import Inventory from "./pages/Inventory";
import Reviews from "./pages/Reviews";
import Categories from "./pages/Categories";
import Collections from "./pages/Collections";
import Homepage from "./pages/Homepage";
import Content from "./pages/Content";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import Customers from "./pages/Customers";
import Coupons from "./pages/Coupons";
import Newsletter from "./pages/Newsletter";
import MediaLibrary from "./pages/MediaLibrary";
import SettingsPage from "./pages/SettingsPage";

export default function AdminApp() {
  const { user, checked } = useAdmin();

  if (!checked) return <div className="min-h-screen bg-[#070708] flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user) return <AdminLogin />;

  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Overview />} />
        <Route path="products" element={<Products />} />
        <Route path="products/new" element={<ProductEdit />} />
        <Route path="products/:id" element={<ProductEdit />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="categories" element={<Categories />} />
        <Route path="collections" element={<Collections />} />
        <Route path="homepage" element={<Homepage />} />
        <Route path="content" element={<Content />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:id" element={<OrderDetail />} />
        <Route path="customers" element={<Customers />} />
        <Route path="coupons" element={<Coupons />} />
        <Route path="newsletter" element={<Newsletter />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="settings" element={<SettingsPage />} />
      </Routes>
    </AdminLayout>
  );
}
